import Utils from "./util";
import Audio from "./audio";
class AudioTuner {
  constructor(component) {
    this.tuner = new Audio();
    this.component = component;
    this.utils = new Utils();
    this.stopped = false;
  }

  start() {
    const self = this;
    self.stopped = false;
    this.tuner.onNoteDetected = function (note) {
      if (self.lastNote === note.name) {
        self.update(note);
      } else {
        self.lastNote = note.name;
      }
    };

    self.tuner.init();
    self.frequencyData = new Uint8Array(self.tuner.analyser.frequencyBinCount);
  }

  animateTuner(note) {
    let rotation = (note.cents / 50) * 45;
    let animationCenter = document.querySelector(".animate-tuner");

    if (rotation < 10 && rotation > -10)
      document.getElementById("svgPath").style.fill = "#155e15";
    else if (rotation > 0)
      document.getElementById("svgPath").style.fill = "#3232bb";
    else if (rotation < 0)
      document.getElementById("svgPath").style.fill = "#a02121";

    animationCenter.style.transform = "rotate(" + rotation + "deg)";
  }

  highlightPianoKey(note, bridgeColor = "") {
    this.utils.resetPianoKeys();
    let pianoKey = document.querySelector(
      `.react-piano-key[data-note="${note}"]`
    );
    if (pianoKey && pianoKey.classList.contains("midi-played")) {
      pianoKey.children[1].classList.add("highlighted");
    } else {
      if (pianoKey && bridgeColor === "")
        pianoKey.classList.add("react-piano-key-highlighted");
      else if (pianoKey && bridgeColor !== "") {
        pianoKey.classList.add("react-piano-key-highlighted");
        pianoKey.classList.add(bridgeColor);
      }
    }
  }

  update(tempNote) {
    if (this.stopped) return;

    let tones = this.component.props.tones;
    let note = tempNote.name + tempNote.octave;
    let frequency = tempNote.frequency.toFixed(2);

    this.animateTuner(tempNote);

    // Different shade based on bridge values
    if (tones.validNotes) {
      let indexCurrentNote = tones.validNotes.findIndex((x) => x === note);
      if (
        indexCurrentNote >= tones.indexBridgeStart &&
        indexCurrentNote <= tones.indexBridgeEnd
      ) {
        this.highlightPianoKey(note, "bridge");
      } else {
        this.highlightPianoKey(note);
      }
      // if (indexCurrentNote < tones.indexBridgeStart)
      //   this.highlightPianoKey(note, "under-bridge");
      // else if (tones.indexBridgeEnd < indexCurrentNote)
      //   this.highlightPianoKey(note, "over-bridge");
    } else {
      this.highlightPianoKey(note);
    }

    this.component.setState({ note, frequency });
  }
}
export default AudioTuner;
